<template lang="html">
  <d-button-group class="buttons">
    <d-dropdown text="Enviar" theme="info">
      <a href="#" class="dropdown-item" @click.prevent="openModal('send_quotation_modal')" :disabled="!quotation.customer.email">
        <i class="fas fa-envelope"></i><span class="d-none d-lg-inline"> E-mail</span>
      </a>
      <a href="#" class="dropdown-item" @click.prevent="openModal('send_whats_quotation_modal')" :disabled="!quotation.customer.phone">
        <i class="fab fa-whatsapp"></i><span class="d-none d-lg-inline"> Whatsapp</span>
      </a>
    </d-dropdown>
    <d-dropdown text="Imprimir">
      <d-dropdown-item>
        <i class="fas fa-print"></i><span class="d-inline" @click.prevent="printQuotation()"> Orçamento</span>
      </d-dropdown-item>
    </d-dropdown>
    <d-button size="sm" class="btn-secondary" @click.prevent="duplicate()">
      <i class="fas fa-copy"></i><span class="d-none d-lg-inline"> Duplicar</span>
    </d-button>
    <d-button v-if="!quotation.able_create_sample && quotation.status === 'approved'" size="sm" class="btn-success px-0" @click.prevent="redirectSamples()">
      <i class="fas fa-eye"></i><span class="d-none d-lg-inline text-nowrap"> Ver amostras</span>
    </d-button>
    <d-button v-else size="sm" class="btn-success" @click.prevent="sample()" :disabled="!quotation.able_create_sample">
      <i class="fas fa-plus"></i><span class="d-none d-lg-inline"> Amostra</span>
    </d-button>
    <d-button size="sm" class="btn-danger" @click.prevent="confirmDeleteRow()">
      <i class="fas fa-trash"></i><span class="d-none d-lg-inline"> Deletar</span>
    </d-button>
  </d-button-group>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import QuotationService from '_services/rest/modules/quotation';
import { _OPEN_MODAL_, _LOAD_MODEL_, _DELETE_QUOTATION_ } from '_modules/quotation/components/QuotationModel';
import { openPdf, catchPdf } from '_utils/require';

export default {
  name: 'quotation-buttons',
  props: {
    quotation: {
      type: Object,
      default: null,
    },
  },
  components: {},
  computed: {},
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
    ]),
    confirmDeleteRow() {
      this.setToggle({ type: 'confirm_modal', bool: true });
      Events.$emit(_DELETE_QUOTATION_, this.quotation);
    },
    duplicate() {
      this.setToggle({ type: 'progress', bool: true });
      QuotationService.duplicate(this.quotation.id)
        .then(response => {
          this.activeAlert({ message: 'Orçamento duplicado com sucesso', theme: 'success' });
          Events.$emit(_LOAD_MODEL_, response);
          this.$router.push(`/admin/orcamentos/${response.id}`);
        })
        .catch(error => this.activeAlert({ message: error.message, theme: 'danger' }))
        .finally(() => this.setToggle({ type: 'progress', bool: false }));
    },
    sample() {
      this.setToggle({ type: 'progress', bool: true });
      QuotationService.sample(this.quotation.id)
        .then(response => {
          this.activeAlert({ message: 'Plano de amostragem criado com sucesso', theme: 'success' });
          this.$emit('update:quotation', response);
          this.$store.commit('setQuotation', response);
        })
        .catch(error => this.activeAlert({ message: error.message, theme: 'danger' }))
        .finally(() => this.setToggle({ type: 'progress', bool: false }));
    },
    redirectSamples() {
      this.$router.push({
        name: 'admin-sample-list',
        params: {
          page: 1,
          quotationId: this.quotation.id,
        },
      });
    },
    printQuotation() {
      this.setToggle({ type: 'progress', bool: true });
      QuotationService.print(this.quotation.id)
        .then(response => openPdf(response))
        .catch(error => this.activeAlert({ message: catchPdf(error.message), theme: 'danger' }))
        .finally(() => this.setToggle({ type: 'progress', bool: false }));
    },
    openModal(type = 'send_whats_quotation_modal') {
      this.setToggle({ type, bool: true });
      Events.$emit(_OPEN_MODAL_, { quotation: this.quotation, type });
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.btn-success {
  &:disabled {
    border-color: #ababab;
    background: #b8b8b8;
  }
}
</style>
